import { memo } from 'react'
import { Page } from 'react-pdf'

export const PDFPage = memo(function PDFPage({
  pageNumber,
  containerWidth,
  fitToWidth,
  scaleFactor,
  rotation,
}: {
  pageNumber: number
  containerWidth: number
  fitToWidth: boolean
  scaleFactor: number
  rotation?: number
}) {
  return (
    <Page
      className="mx-auto w-fit"
      pageNumber={pageNumber}
      width={containerWidth - (fitToWidth ? 12 * 2 : 66 * 2)} // subtract padding
      scale={scaleFactor}
      rotate={rotation}
      renderAnnotationLayer={false}
      renderTextLayer={false}
    />
  )
})
